import { Box } from '@mui/material'
import styles from './SecondaryNavShell.module.scss'

function SecondaryNavShell({ isChambers = false, collapsedForRail = false, children }) {
  const collapsedClass = collapsedForRail ? styles.shellCollapsedForRail : ''
  return (
    <Box
      component="nav"
      className={`${styles.shell} ${isChambers ? styles.shellChambers : styles.shellHome} ${collapsedClass}`}
    >
      {children}
    </Box>
  )
}

export default SecondaryNavShell
